import * as React from 'react';

function SvgHistory(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" {...props}>
      <path d="M68.1 65.2H6.8V3.9C6.8 2.3 5.5 1 3.9 1S1 2.3 1 3.9v64.2C1 69.7 2.3 71 3.9 71h64.2c1.6 0 2.9-1.3 2.9-2.9 0-1.6-1.3-2.9-2.9-2.9z" />
      <path d="M62 34.9c-1.1.2-2 .7-2.8 1.4l-8.8-4.8c.1-.6.1-1.3 0-1.9-.6-3.1-3.5-5.2-6.7-4.6-3.1.6-5.2 3.5-4.6 6.7.1.7.3 1.3.7 1.8L33.3 41c-1-.4-2-.5-3.1-.3s-2.1.7-2.9 1.5l-8.8-4.5c.2-.7.2-1.5.1-2.3-.6-3.1-3.5-5.2-6.7-4.6s-5.2 3.5-4.6 6.7 3.5 5.2 6.7 4.6c.9-.2 1.8-.6 2.5-1.1l9.1 4.7c-.1.6-.1 1.2 0 1.8.6 3.1 3.5 5.2 6.7 4.6 3.1-.6 5.2-3.5 4.6-6.7-.1-.7-.3-1.3-.7-1.8l6.5-7.6c1 .4 2 .5 3.1.3s2-.7 2.8-1.4l8.8 4.8c-.1.6-.1 1.3 0 1.9.6 3.1 3.5 5.2 6.7 4.6 3.1-.6 5.2-3.5 4.6-6.7-.6-3.1-3.6-5.1-6.7-4.6z" />
    </svg>
  );
}

export default SvgHistory;
